let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("AIiTi")).then(() => parcelRequire('ceO1g'));